import { render, staticRenderFns } from "./RegularizationViewInfo.vue?vue&type=template&id=9104fc7c&"
import script from "./RegularizationViewInfo.vue?vue&type=script&lang=js&"
export * from "./RegularizationViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports